var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 5.5,
    fill: "#F7F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 5.5,
    stroke: "#F1F1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2918 30.1246C25.8371 30.1246 29.9652 23.8719 29.9652 18.4512C29.9652 18.2754 29.9613 18.0957 29.9535 17.9199C30.7566 17.3392 31.4496 16.6198 32 15.7957C31.2521 16.1285 30.458 16.3458 29.6449 16.4402C30.5011 15.9271 31.1421 15.1209 31.4492 14.1711C30.6438 14.6484 29.763 14.9851 28.8445 15.1668C28.2257 14.5093 27.4075 14.0739 26.5164 13.928C25.6253 13.7821 24.711 13.9338 23.9148 14.3597C23.1186 14.7856 22.4848 15.4619 22.1115 16.2841C21.7382 17.1062 21.6462 18.0285 21.8496 18.9082C20.2187 18.8264 18.6233 18.4027 17.1667 17.6647C15.71 16.9267 14.4247 15.8908 13.3941 14.6242C12.8703 15.5273 12.71 16.596 12.9459 17.613C13.1817 18.6301 13.7959 19.5192 14.6637 20.0996C14.0122 20.0789 13.375 19.9035 12.8047 19.5879V19.6387C12.8041 20.5864 13.1317 21.5051 13.7319 22.2386C14.3321 22.9721 15.1678 23.4751 16.0969 23.6621C15.4934 23.8272 14.86 23.8513 14.2457 23.7324C14.5079 24.5475 15.018 25.2604 15.7048 25.7716C16.3916 26.2828 17.2209 26.5668 18.077 26.584C16.6237 27.7256 14.8285 28.3447 12.9805 28.3418C12.6527 28.3413 12.3253 28.3212 12 28.2817C13.8774 29.4861 16.0613 30.1258 18.2918 30.1246Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.e325fc778294e57ab61f5c8cced1f9f7.svg";
export { ForwardRef as ReactComponent };